function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M63.9 49.1h155.6v14.5H63.9V49.1zm0 28.4h155.6V92H63.9V77.5zm176.7-49v84.3H42.9V28.5h197.7M269.1 0H14.4v141.3h254.7V0zM138.5 161.5l-7.8 23.5 7.1 21.2-6.3 18.9 13.4 4.5 7.8-23.4-7-21.2 6.3-19-13.5-4.5zm38.9 0l-7.8 23.5 7.1 21.2-6.4 18.9 13.5 4.5 7.8-23.4-7.1-21.2 6.4-19-13.5-4.5zm-64.3 4.5l-13.4-4.5-7.8 23.5 7.1 21.2-6.4 18.9 13.5 4.5 7.8-23.4-7.1-21.2 6.3-19z"
})));